import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from './auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take, map, Observable } from 'rxjs';

export const viewerGuard: CanMatchFn = (): Observable<boolean> => {
  const authService = inject(AuthService);

  return toObservable(authService.isAuthResolved).pipe(
    filter((resolved) => resolved),
    take(1),
    map(() => authService.userRole() === 'viewer')
  );
};
